import { AloftDate } from '@aloft/toolkit-shared';

import formatISO from 'date-fns/formatISO';
import parse from 'date-fns/parse';

const regexIsoDate = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
const regexExcelDate = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{2}$/;
const regexExcelDateFullYear = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/;

export const getAloftDateFromRawString = (effectiveDateRaw: string): AloftDate => {
  const cleanedDateString = effectiveDateRaw.trim();
  if (cleanedDateString.match(regexIsoDate)) {
    return AloftDate.fromIsoString(cleanedDateString);
  }
  if (cleanedDateString.match(regexExcelDate)) {
    const nativeDate = parse(cleanedDateString, 'MM/dd/yy', new Date());

    return AloftDate.fromIsoString(formatISO(nativeDate, { representation: 'date' }));
  }
  if (cleanedDateString.match(regexExcelDateFullYear)) {
    const nativeDate = parse(cleanedDateString, 'MM/dd/yyyy', new Date());

    return AloftDate.fromIsoString(formatISO(nativeDate, { representation: 'date' }));
  }

  throw Error('Invalid date format provided');
};
